'use client';

import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface ConfigValue {
  /** ComusFlow account app (login / signup), e.g. https://app.comusflow.com */
  appUrl: string;
  /** ComusLive discovery portal (public events), e.g. https://comuslive.com */
  comusliveUrl: string;
}

const ConfigContext = createContext<ConfigValue>({
  appUrl: 'https://app.comusflow.com',
  comusliveUrl: 'https://comuslive.com',
});

interface ConfigProviderProps {
  appUrl: string;
  comusliveUrl: string;
  children: ReactNode;
}

export function ConfigProvider({ appUrl, comusliveUrl, children }: ConfigProviderProps) {
  return (
    <ConfigContext.Provider value={{ appUrl, comusliveUrl }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig(): ConfigValue {
  return useContext(ConfigContext);
}
